export const operatorTypeSelect = [
    {
        value: 'Casino',
        display: 'Casino'
    },
    {
        value: 'Operator',
        display: 'Operator'
    }
]